import { faFrown } from '@fortawesome/pro-solid-svg-icons/faFrown';
import _pt from 'prop-types';
import 'react';
import { createBemBlockBuilder } from '@ebsco-ui/utils';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { jsxs, jsx } from 'react/jsx-runtime';

var Error = function Error(_ref) {
  var children = _ref.children,
      consumerBlockClassName = _ref.className,
      title = _ref.title,
      description = _ref.description;
  var getBemBlocksWith = createBemBlockBuilder(["eb-error", consumerBlockClassName]);
  return /*#__PURE__*/jsxs("div", {
    className: getBemBlocksWith(),
    children: [/*#__PURE__*/jsx("div", {
      className: getBemBlocksWith("__icon"),
      children: /*#__PURE__*/jsx(FontAwesomeIcon, {
        icon: faFrown
      })
    }), /*#__PURE__*/jsxs("div", {
      className: getBemBlocksWith("__message"),
      children: [/*#__PURE__*/jsxs("strong", {
        className: getBemBlocksWith("__title"),
        children: [title, "\xA0"]
      }), /*#__PURE__*/jsxs("h2", {
        className: getBemBlocksWith("__description"),
        children: [description, "\xA0"]
      }), /*#__PURE__*/jsx("p", {
        className: getBemBlocksWith("__body"),
        children: children
      })]
    })]
  });
};

Error.propTypes = {
  children: _pt.node.isRequired,
  className: _pt.string,
  title: _pt.string.isRequired,
  description: _pt.string.isRequired
};

export { Error as default };
//# sourceMappingURL=error-esm.js.map
